export default "__VITE_PUBLIC_ASSET__fb00a54d__"